import { buttonVariants } from "@/components/buttons/buttonVariants";
import type { PaginationLinkProps } from "@/components/pagination/types";
import { cn } from "@/utils/cn";

export function PaginationLink({
  className,
  isActive,
  size = "icon",
  ...props
}: PaginationLinkProps) {
  return (
    <button
      aria-current={isActive === true ? "page" : undefined}
      className={cn(
        buttonVariants({
          variant: isActive === true ? "outline" : "ghost",
          size,
        }),
        className
      )}
      {...props}
    />
  );
}
PaginationLink.displayName = "PaginationLink";
